"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof3 = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  PostHogCoreStateless: true,
  PostHogCore: true,
  utils: true,
  LZString: true
};
Object.defineProperty(exports, "LZString", {
  enumerable: true,
  get: function get() {
    return _lzString.LZString;
  }
});
exports.utils = exports.PostHogCoreStateless = exports.PostHogCore = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _wrapNativeSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/wrapNativeSuper"));
var _types = require("./types");
Object.keys(_types).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _types[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _types[key];
    }
  });
});
var _utils = _interopRequireWildcard(require("./utils"));
exports.utils = _utils;
var _lzString = require("./lz-string");
var _eventemitter = require("./eventemitter");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2["default"])(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2["default"])(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return (0, _possibleConstructorReturn2["default"])(this, result);
  };
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
var PostHogFetchHttpError = function (_Error) {
  (0, _inherits2["default"])(PostHogFetchHttpError, _Error);
  var _super = _createSuper(PostHogFetchHttpError);
  function PostHogFetchHttpError(response) {
    var _this;
    (0, _classCallCheck2["default"])(this, PostHogFetchHttpError);
    _this = _super.call(this, 'HTTP error while fetching PostHog: ' + response.status);
    _this.response = response;
    _this.name = 'PostHogFetchHttpError';
    return _this;
  }
  return (0, _createClass2["default"])(PostHogFetchHttpError);
}((0, _wrapNativeSuper2["default"])(Error));
var PostHogFetchNetworkError = function (_Error2) {
  (0, _inherits2["default"])(PostHogFetchNetworkError, _Error2);
  var _super2 = _createSuper(PostHogFetchNetworkError);
  function PostHogFetchNetworkError(error) {
    var _this2;
    (0, _classCallCheck2["default"])(this, PostHogFetchNetworkError);
    _this2 = _super2.call(this, 'Network error while fetching PostHog', error instanceof Error ? {
      cause: error
    } : {});
    _this2.error = error;
    _this2.name = 'PostHogFetchNetworkError';
    return _this2;
  }
  return (0, _createClass2["default"])(PostHogFetchNetworkError);
}((0, _wrapNativeSuper2["default"])(Error));
function isPostHogFetchError(err) {
  return (0, _typeof2["default"])(err) === 'object' && (err.name === 'PostHogFetchHttpError' || err.name === 'PostHogFetchNetworkError');
}
var PostHogCoreStateless = function () {
  function PostHogCoreStateless(apiKey, options) {
    (0, _classCallCheck2["default"])(this, PostHogCoreStateless);
    var _a, _b, _c, _d, _e;
    this.debugMode = false;
    this.pendingPromises = {};
    this.disableGeoip = true;
    this._events = new _eventemitter.SimpleEventEmitter();
    (0, _utils.assert)(apiKey, "You must pass your PostHog project's api key.");
    this.apiKey = apiKey;
    this.host = (0, _utils.removeTrailingSlash)((options === null || options === void 0 ? void 0 : options.host) || 'https://app.posthog.com');
    this.flushAt = (options === null || options === void 0 ? void 0 : options.flushAt) ? Math.max(options === null || options === void 0 ? void 0 : options.flushAt, 1) : 20;
    this.flushInterval = (_a = options === null || options === void 0 ? void 0 : options.flushInterval) !== null && _a !== void 0 ? _a : 10000;
    this.captureMode = (options === null || options === void 0 ? void 0 : options.captureMode) || 'form';
    this._optoutOverride = (options === null || options === void 0 ? void 0 : options.enable) === false;
    this._retryOptions = {
      retryCount: (_b = options === null || options === void 0 ? void 0 : options.fetchRetryCount) !== null && _b !== void 0 ? _b : 3,
      retryDelay: (_c = options === null || options === void 0 ? void 0 : options.fetchRetryDelay) !== null && _c !== void 0 ? _c : 3000,
      retryCheck: isPostHogFetchError
    };
    this.requestTimeout = (_d = options === null || options === void 0 ? void 0 : options.requestTimeout) !== null && _d !== void 0 ? _d : 10000;
    this.disableGeoip = (_e = options === null || options === void 0 ? void 0 : options.disableGeoip) !== null && _e !== void 0 ? _e : true;
  }
  (0, _createClass2["default"])(PostHogCoreStateless, [{
    key: "getCommonEventProperties",
    value: function getCommonEventProperties() {
      return {
        $lib: this.getLibraryId(),
        $lib_version: this.getLibraryVersion()
      };
    }
  }, {
    key: "optedOut",
    get: function get() {
      var _a, _b;
      return (_b = (_a = this.getPersistedProperty(_types.PostHogPersistedProperty.OptedOut)) !== null && _a !== void 0 ? _a : this._optoutOverride) !== null && _b !== void 0 ? _b : false;
    }
  }, {
    key: "optIn",
    value: function optIn() {
      this.setPersistedProperty(_types.PostHogPersistedProperty.OptedOut, false);
    }
  }, {
    key: "optOut",
    value: function optOut() {
      this.setPersistedProperty(_types.PostHogPersistedProperty.OptedOut, true);
    }
  }, {
    key: "on",
    value: function on(event, cb) {
      return this._events.on(event, cb);
    }
  }, {
    key: "debug",
    value: function debug() {
      var enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var _a;
      (_a = this.removeDebugCallback) === null || _a === void 0 ? void 0 : _a.call(this);
      this.debugMode = enabled;
      if (enabled) {
        this.removeDebugCallback = this.on('*', function (event, payload) {
          return console.log('PostHog Debug', event, payload);
        });
      }
    }
  }, {
    key: "buildPayload",
    value: function buildPayload(payload) {
      return {
        distinct_id: payload.distinct_id,
        event: payload.event,
        properties: _objectSpread(_objectSpread({}, payload.properties || {}), this.getCommonEventProperties())
      };
    }
  }, {
    key: "identifyStateless",
    value: function identifyStateless(distinctId, properties, options) {
      var payload = _objectSpread({}, this.buildPayload({
        distinct_id: distinctId,
        event: '$identify',
        properties: properties
      }));
      this.enqueue('identify', payload, options);
      return this;
    }
  }, {
    key: "captureStateless",
    value: function captureStateless(distinctId, event, properties, options) {
      var payload = this.buildPayload({
        distinct_id: distinctId,
        event: event,
        properties: properties
      });
      this.enqueue('capture', payload, options);
      return this;
    }
  }, {
    key: "aliasStateless",
    value: function aliasStateless(alias, distinctId, properties, options) {
      var payload = this.buildPayload({
        event: '$create_alias',
        distinct_id: distinctId,
        properties: _objectSpread(_objectSpread({}, properties || {}), {}, {
          distinct_id: distinctId,
          alias: alias
        })
      });
      this.enqueue('alias', payload, options);
      return this;
    }
  }, {
    key: "groupIdentifyStateless",
    value: function groupIdentifyStateless(groupType, groupKey, groupProperties, options, distinctId, eventProperties) {
      var payload = this.buildPayload({
        distinct_id: distinctId || "$".concat(groupType, "_").concat(groupKey),
        event: '$groupidentify',
        properties: _objectSpread({
          $group_type: groupType,
          $group_key: groupKey,
          $group_set: groupProperties || {}
        }, eventProperties || {})
      });
      this.enqueue('capture', payload, options);
      return this;
    }
  }, {
    key: "getDecide",
    value: function () {
      var _getDecide = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee(distinctId) {
        var groups,
          personProperties,
          groupProperties,
          extraPayload,
          url,
          fetchOptions,
          _args = arguments;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                groups = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
                personProperties = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};
                groupProperties = _args.length > 3 && _args[3] !== undefined ? _args[3] : {};
                extraPayload = _args.length > 4 && _args[4] !== undefined ? _args[4] : {};
                url = "".concat(this.host, "/decide/?v=3");
                fetchOptions = {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: JSON.stringify(_objectSpread({
                    token: this.apiKey,
                    distinct_id: distinctId,
                    groups: groups,
                    person_properties: personProperties,
                    group_properties: groupProperties
                  }, extraPayload))
                };
                return _context.abrupt("return", this.fetchWithRetry(url, fetchOptions).then(function (response) {
                  return response.json();
                })["catch"](function (error) {
                  console.error('Error fetching feature flags', error);
                  return undefined;
                }));
              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function getDecide(_x) {
        return _getDecide.apply(this, arguments);
      }
      return getDecide;
    }()
  }, {
    key: "getFeatureFlagStateless",
    value: function () {
      var _getFeatureFlagStateless = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee2(key, distinctId) {
        var groups,
          personProperties,
          groupProperties,
          disableGeoip,
          featureFlags,
          response,
          _args2 = arguments;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                groups = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : {};
                personProperties = _args2.length > 3 && _args2[3] !== undefined ? _args2[3] : {};
                groupProperties = _args2.length > 4 && _args2[4] !== undefined ? _args2[4] : {};
                disableGeoip = _args2.length > 5 ? _args2[5] : undefined;
                _context2.next = 6;
                return this.getFeatureFlagsStateless(distinctId, groups, personProperties, groupProperties, disableGeoip);
              case 6:
                featureFlags = _context2.sent;
                if (featureFlags) {
                  _context2.next = 9;
                  break;
                }
                return _context2.abrupt("return", undefined);
              case 9:
                response = featureFlags[key];
                if (response === undefined) {
                  response = false;
                }
                return _context2.abrupt("return", response);
              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
      function getFeatureFlagStateless(_x2, _x3) {
        return _getFeatureFlagStateless.apply(this, arguments);
      }
      return getFeatureFlagStateless;
    }()
  }, {
    key: "getFeatureFlagPayloadStateless",
    value: function () {
      var _getFeatureFlagPayloadStateless = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee3(key, distinctId) {
        var groups,
          personProperties,
          groupProperties,
          disableGeoip,
          payloads,
          response,
          _args3 = arguments;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                groups = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : {};
                personProperties = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : {};
                groupProperties = _args3.length > 4 && _args3[4] !== undefined ? _args3[4] : {};
                disableGeoip = _args3.length > 5 ? _args3[5] : undefined;
                _context3.next = 6;
                return this.getFeatureFlagPayloadsStateless(distinctId, groups, personProperties, groupProperties, disableGeoip);
              case 6:
                payloads = _context3.sent;
                if (payloads) {
                  _context3.next = 9;
                  break;
                }
                return _context3.abrupt("return", undefined);
              case 9:
                response = payloads[key];
                if (!(response === undefined)) {
                  _context3.next = 12;
                  break;
                }
                return _context3.abrupt("return", null);
              case 12:
                return _context3.abrupt("return", this._parsePayload(response));
              case 13:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
      function getFeatureFlagPayloadStateless(_x4, _x5) {
        return _getFeatureFlagPayloadStateless.apply(this, arguments);
      }
      return getFeatureFlagPayloadStateless;
    }()
  }, {
    key: "getFeatureFlagPayloadsStateless",
    value: function () {
      var _getFeatureFlagPayloadsStateless = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee4(distinctId) {
        var _this3 = this;
        var groups,
          personProperties,
          groupProperties,
          disableGeoip,
          payloads,
          _args4 = arguments;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                groups = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : {};
                personProperties = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : {};
                groupProperties = _args4.length > 3 && _args4[3] !== undefined ? _args4[3] : {};
                disableGeoip = _args4.length > 4 ? _args4[4] : undefined;
                _context4.next = 6;
                return this.getFeatureFlagsAndPayloadsStateless(distinctId, groups, personProperties, groupProperties, disableGeoip);
              case 6:
                payloads = _context4.sent.payloads;
                if (!payloads) {
                  _context4.next = 9;
                  break;
                }
                return _context4.abrupt("return", Object.fromEntries(Object.entries(payloads).map(function (_ref) {
                  var _ref2 = (0, _slicedToArray2["default"])(_ref, 2),
                    k = _ref2[0],
                    v = _ref2[1];
                  return [k, _this3._parsePayload(v)];
                })));
              case 9:
                return _context4.abrupt("return", payloads);
              case 10:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
      function getFeatureFlagPayloadsStateless(_x6) {
        return _getFeatureFlagPayloadsStateless.apply(this, arguments);
      }
      return getFeatureFlagPayloadsStateless;
    }()
  }, {
    key: "_parsePayload",
    value: function _parsePayload(response) {
      try {
        return JSON.parse(response);
      } catch (_a) {
        return response;
      }
    }
  }, {
    key: "getFeatureFlagsStateless",
    value: function () {
      var _getFeatureFlagsStateless = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee5(distinctId) {
        var groups,
          personProperties,
          groupProperties,
          disableGeoip,
          _args5 = arguments;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                groups = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : {};
                personProperties = _args5.length > 2 && _args5[2] !== undefined ? _args5[2] : {};
                groupProperties = _args5.length > 3 && _args5[3] !== undefined ? _args5[3] : {};
                disableGeoip = _args5.length > 4 ? _args5[4] : undefined;
                _context5.next = 6;
                return this.getFeatureFlagsAndPayloadsStateless(distinctId, groups, personProperties, groupProperties, disableGeoip);
              case 6:
                return _context5.abrupt("return", _context5.sent.flags);
              case 7:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
      function getFeatureFlagsStateless(_x7) {
        return _getFeatureFlagsStateless.apply(this, arguments);
      }
      return getFeatureFlagsStateless;
    }()
  }, {
    key: "getFeatureFlagsAndPayloadsStateless",
    value: function () {
      var _getFeatureFlagsAndPayloadsStateless = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee6(distinctId) {
        var groups,
          personProperties,
          groupProperties,
          disableGeoip,
          extraPayload,
          decideResponse,
          flags,
          payloads,
          _args6 = arguments;
        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                groups = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : {};
                personProperties = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : {};
                groupProperties = _args6.length > 3 && _args6[3] !== undefined ? _args6[3] : {};
                disableGeoip = _args6.length > 4 ? _args6[4] : undefined;
                extraPayload = {};
                if (disableGeoip !== null && disableGeoip !== void 0 ? disableGeoip : this.disableGeoip) {
                  extraPayload['geoip_disable'] = true;
                }
                _context6.next = 8;
                return this.getDecide(distinctId, groups, personProperties, groupProperties, extraPayload);
              case 8:
                decideResponse = _context6.sent;
                flags = decideResponse === null || decideResponse === void 0 ? void 0 : decideResponse.featureFlags;
                payloads = decideResponse === null || decideResponse === void 0 ? void 0 : decideResponse.featureFlagPayloads;
                return _context6.abrupt("return", {
                  flags: flags,
                  payloads: payloads
                });
              case 12:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));
      function getFeatureFlagsAndPayloadsStateless(_x8) {
        return _getFeatureFlagsAndPayloadsStateless.apply(this, arguments);
      }
      return getFeatureFlagsAndPayloadsStateless;
    }()
  }, {
    key: "enqueue",
    value: function enqueue(type, _message, options) {
      var _this4 = this;
      var _a;
      if (this.optedOut) {
        this._events.emit(type, "Library is disabled. Not sending event. To re-enable, call posthog.enable()");
        return;
      }
      var message = _objectSpread(_objectSpread({}, _message), {}, {
        type: type,
        library: this.getLibraryId(),
        library_version: this.getLibraryVersion(),
        timestamp: (options === null || options === void 0 ? void 0 : options.timestamp) ? options === null || options === void 0 ? void 0 : options.timestamp : (0, _utils.currentISOTime)()
      });
      var addGeoipDisableProperty = (_a = options === null || options === void 0 ? void 0 : options.disableGeoip) !== null && _a !== void 0 ? _a : this.disableGeoip;
      if (addGeoipDisableProperty) {
        if (!message.properties) {
          message.properties = {};
        }
        message['properties']['$geoip_disable'] = true;
      }
      if (message.distinctId) {
        message.distinct_id = message.distinctId;
        delete message.distinctId;
      }
      var queue = this.getPersistedProperty(_types.PostHogPersistedProperty.Queue) || [];
      queue.push({
        message: message
      });
      this.setPersistedProperty(_types.PostHogPersistedProperty.Queue, queue);
      this._events.emit(type, message);
      if (queue.length >= this.flushAt) {
        this.flush();
      }
      if (this.flushInterval && !this._flushTimer) {
        this._flushTimer = (0, _utils.safeSetTimeout)(function () {
          return _this4.flush();
        }, this.flushInterval);
      }
    }
  }, {
    key: "flushAsync",
    value: function flushAsync() {
      var _this5 = this;
      return new Promise(function (resolve, reject) {
        _this5.flush(function (err, data) {
          return err ? reject(err) : resolve(data);
        });
      });
    }
  }, {
    key: "flush",
    value: function flush(callback) {
      var _this6 = this;
      if (this._flushTimer) {
        clearTimeout(this._flushTimer);
        this._flushTimer = null;
      }
      var queue = this.getPersistedProperty(_types.PostHogPersistedProperty.Queue) || [];
      if (!queue.length) {
        return callback === null || callback === void 0 ? void 0 : callback();
      }
      var items = queue.splice(0, this.flushAt);
      this.setPersistedProperty(_types.PostHogPersistedProperty.Queue, queue);
      var messages = items.map(function (item) {
        return item.message;
      });
      var data = {
        api_key: this.apiKey,
        batch: messages,
        sent_at: (0, _utils.currentISOTime)()
      };
      var promiseUUID = (0, _utils.generateUUID)();
      var done = function done(err) {
        if (err) {
          _this6._events.emit('error', err);
        }
        callback === null || callback === void 0 ? void 0 : callback(err, messages);
        delete _this6.pendingPromises[promiseUUID];
        _this6._events.emit('flush', messages);
      };
      var customUserAgent = this.getCustomUserAgent();
      var headers = {};
      if (customUserAgent) {
        headers['user-agent'] = customUserAgent;
      }
      var payload = JSON.stringify(data);
      var url = this.captureMode === 'form' ? "".concat(this.host, "/e/?ip=1&_=").concat((0, _utils.currentTimestamp)(), "&v=").concat(this.getLibraryVersion()) : "".concat(this.host, "/batch/");
      var fetchOptions = this.captureMode === 'form' ? {
        method: 'POST',
        mode: 'no-cors',
        credentials: 'omit',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: "data=".concat(encodeURIComponent(_lzString.LZString.compressToBase64(payload)), "&compression=lz64")
      } : {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: payload
      };
      var requestPromise = this.fetchWithRetry(url, fetchOptions);
      this.pendingPromises[promiseUUID] = requestPromise;
      requestPromise.then(function () {
        return done();
      })["catch"](function (err) {
        done(err);
      });
    }
  }, {
    key: "fetchWithRetry",
    value: function () {
      var _fetchWithRetry = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee8(url, options, retryOptions) {
        var _this7 = this;
        var _a, _b;
        return _regenerator["default"].wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                ;
                (_a = (_b = AbortSignal).timeout) !== null && _a !== void 0 ? _a : _b.timeout = function timeout(ms) {
                  var ctrl = new AbortController();
                  setTimeout(function () {
                    return ctrl.abort();
                  }, ms);
                  return ctrl.signal;
                };
                _context8.next = 4;
                return (0, _utils.retriable)((0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee7() {
                  var res;
                  return _regenerator["default"].wrap(function _callee7$(_context7) {
                    while (1) {
                      switch (_context7.prev = _context7.next) {
                        case 0:
                          res = null;
                          _context7.prev = 1;
                          _context7.next = 4;
                          return _this7.fetch(url, _objectSpread({
                            signal: AbortSignal.timeout(_this7.requestTimeout)
                          }, options));
                        case 4:
                          res = _context7.sent;
                          _context7.next = 10;
                          break;
                        case 7:
                          _context7.prev = 7;
                          _context7.t0 = _context7["catch"](1);
                          throw new PostHogFetchNetworkError(_context7.t0);
                        case 10:
                          if (!(res.status < 200 || res.status >= 400)) {
                            _context7.next = 12;
                            break;
                          }
                          throw new PostHogFetchHttpError(res);
                        case 12:
                          return _context7.abrupt("return", res);
                        case 13:
                        case "end":
                          return _context7.stop();
                      }
                    }
                  }, _callee7, null, [[1, 7]]);
                })), _objectSpread(_objectSpread({}, this._retryOptions), retryOptions));
              case 4:
                return _context8.abrupt("return", _context8.sent);
              case 5:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));
      function fetchWithRetry(_x9, _x10, _x11) {
        return _fetchWithRetry.apply(this, arguments);
      }
      return fetchWithRetry;
    }()
  }, {
    key: "shutdownAsync",
    value: function () {
      var _shutdownAsync = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee9() {
        return _regenerator["default"].wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                clearTimeout(this._flushTimer);
                _context9.prev = 1;
                _context9.next = 4;
                return this.flushAsync();
              case 4:
                _context9.next = 6;
                return Promise.all(Object.values(this.pendingPromises).map(function (x) {
                  return x["catch"](function () {});
                }));
              case 6:
                _context9.next = 13;
                break;
              case 8:
                _context9.prev = 8;
                _context9.t0 = _context9["catch"](1);
                if (isPostHogFetchError(_context9.t0)) {
                  _context9.next = 12;
                  break;
                }
                throw _context9.t0;
              case 12:
                console.error('Error while shutting down PostHog', _context9.t0);
              case 13:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this, [[1, 8]]);
      }));
      function shutdownAsync() {
        return _shutdownAsync.apply(this, arguments);
      }
      return shutdownAsync;
    }()
  }, {
    key: "shutdown",
    value: function shutdown() {
      void this.shutdownAsync();
    }
  }]);
  return PostHogCoreStateless;
}();
exports.PostHogCoreStateless = PostHogCoreStateless;
var PostHogCore = function (_PostHogCoreStateless) {
  (0, _inherits2["default"])(PostHogCore, _PostHogCoreStateless);
  var _super3 = _createSuper(PostHogCore);
  function PostHogCore(apiKey, options) {
    var _this8;
    (0, _classCallCheck2["default"])(this, PostHogCore);
    var _a, _b, _c;
    var disableGeoipOption = (_a = options === null || options === void 0 ? void 0 : options.disableGeoip) !== null && _a !== void 0 ? _a : false;
    _this8 = _super3.call(this, apiKey, _objectSpread(_objectSpread({}, options), {}, {
      disableGeoip: disableGeoipOption
    }));
    _this8.flagCallReported = {};
    _this8.sessionProps = {};
    _this8.sendFeatureFlagEvent = (_b = options === null || options === void 0 ? void 0 : options.sendFeatureFlagEvent) !== null && _b !== void 0 ? _b : true;
    _this8._sessionExpirationTimeSeconds = (_c = options === null || options === void 0 ? void 0 : options.sessionExpirationTimeSeconds) !== null && _c !== void 0 ? _c : 1800;
    return _this8;
  }
  (0, _createClass2["default"])(PostHogCore, [{
    key: "setupBootstrap",
    value: function setupBootstrap(options) {
      var _a, _b, _c, _d;
      if ((_a = options === null || options === void 0 ? void 0 : options.bootstrap) === null || _a === void 0 ? void 0 : _a.distinctId) {
        if ((_b = options === null || options === void 0 ? void 0 : options.bootstrap) === null || _b === void 0 ? void 0 : _b.isIdentifiedId) {
          this.setPersistedProperty(_types.PostHogPersistedProperty.DistinctId, options.bootstrap.distinctId);
        } else {
          this.setPersistedProperty(_types.PostHogPersistedProperty.AnonymousId, options.bootstrap.distinctId);
        }
      }
      if ((_c = options === null || options === void 0 ? void 0 : options.bootstrap) === null || _c === void 0 ? void 0 : _c.featureFlags) {
        var activeFlags = Object.keys(((_d = options.bootstrap) === null || _d === void 0 ? void 0 : _d.featureFlags) || {}).filter(function (flag) {
          var _a, _b;
          return !!((_b = (_a = options.bootstrap) === null || _a === void 0 ? void 0 : _a.featureFlags) === null || _b === void 0 ? void 0 : _b[flag]);
        }).reduce(function (res, key) {
          var _a, _b;
          return res[key] = ((_b = (_a = options.bootstrap) === null || _a === void 0 ? void 0 : _a.featureFlags) === null || _b === void 0 ? void 0 : _b[key]) || false, res;
        }, {});
        this.setKnownFeatureFlags(activeFlags);
        (options === null || options === void 0 ? void 0 : options.bootstrap.featureFlagPayloads) && this.setKnownFeatureFlagPayloads(options === null || options === void 0 ? void 0 : options.bootstrap.featureFlagPayloads);
      }
    }
  }, {
    key: "props",
    get: function get() {
      if (!this._props) {
        this._props = this.getPersistedProperty(_types.PostHogPersistedProperty.Props);
      }
      return this._props || {};
    },
    set: function set(val) {
      this._props = val;
    }
  }, {
    key: "clearProps",
    value: function clearProps() {
      this.props = undefined;
      this.sessionProps = {};
    }
  }, {
    key: "on",
    value: function on(event, cb) {
      return this._events.on(event, cb);
    }
  }, {
    key: "reset",
    value: function reset(propertiesToKeep) {
      var allPropertiesToKeep = [_types.PostHogPersistedProperty.Queue].concat((0, _toConsumableArray2["default"])(propertiesToKeep || []));
      this.clearProps();
      for (var _i = 0, _Object$keys = Object.keys(_types.PostHogPersistedProperty); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i];
        if (!allPropertiesToKeep.includes(_types.PostHogPersistedProperty[key])) {
          this.setPersistedProperty(_types.PostHogPersistedProperty[key], null);
        }
      }
    }
  }, {
    key: "getCommonEventProperties",
    value: function getCommonEventProperties() {
      var featureFlags = this.getFeatureFlags();
      var featureVariantProperties = {};
      if (featureFlags) {
        for (var _i2 = 0, _Object$entries = Object.entries(featureFlags); _i2 < _Object$entries.length; _i2++) {
          var _Object$entries$_i = (0, _slicedToArray2["default"])(_Object$entries[_i2], 2),
            feature = _Object$entries$_i[0],
            variant = _Object$entries$_i[1];
          featureVariantProperties["$feature/".concat(feature)] = variant;
        }
      }
      return _objectSpread(_objectSpread({
        $active_feature_flags: featureFlags ? Object.keys(featureFlags) : undefined
      }, featureVariantProperties), (0, _get2["default"])((0, _getPrototypeOf2["default"])(PostHogCore.prototype), "getCommonEventProperties", this).call(this));
    }
  }, {
    key: "enrichProperties",
    value: function enrichProperties(properties) {
      return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, this.props), this.sessionProps), properties || {}), this.getCommonEventProperties()), {}, {
        $session_id: this.getSessionId()
      });
    }
  }, {
    key: "getSessionId",
    value: function getSessionId() {
      var sessionId = this.getPersistedProperty(_types.PostHogPersistedProperty.SessionId);
      var sessionTimestamp = this.getPersistedProperty(_types.PostHogPersistedProperty.SessionLastTimestamp) || 0;
      if (!sessionId || Date.now() - sessionTimestamp > this._sessionExpirationTimeSeconds * 1000) {
        sessionId = (0, _utils.generateUUID)(globalThis);
        this.setPersistedProperty(_types.PostHogPersistedProperty.SessionId, sessionId);
      }
      this.setPersistedProperty(_types.PostHogPersistedProperty.SessionLastTimestamp, Date.now());
      return sessionId;
    }
  }, {
    key: "resetSessionId",
    value: function resetSessionId() {
      this.setPersistedProperty(_types.PostHogPersistedProperty.SessionId, null);
    }
  }, {
    key: "getAnonymousId",
    value: function getAnonymousId() {
      var anonId = this.getPersistedProperty(_types.PostHogPersistedProperty.AnonymousId);
      if (!anonId) {
        anonId = (0, _utils.generateUUID)(globalThis);
        this.setPersistedProperty(_types.PostHogPersistedProperty.AnonymousId, anonId);
      }
      return anonId;
    }
  }, {
    key: "getDistinctId",
    value: function getDistinctId() {
      return this.getPersistedProperty(_types.PostHogPersistedProperty.DistinctId) || this.getAnonymousId();
    }
  }, {
    key: "unregister",
    value: function unregister(property) {
      delete this.props[property];
      this.setPersistedProperty(_types.PostHogPersistedProperty.Props, this.props);
    }
  }, {
    key: "register",
    value: function register(properties) {
      this.props = _objectSpread(_objectSpread({}, this.props), properties);
      this.setPersistedProperty(_types.PostHogPersistedProperty.Props, this.props);
    }
  }, {
    key: "registerForSession",
    value: function registerForSession(properties) {
      this.sessionProps = _objectSpread(_objectSpread({}, this.sessionProps), properties);
    }
  }, {
    key: "unregisterForSession",
    value: function unregisterForSession(property) {
      delete this.sessionProps[property];
    }
  }, {
    key: "identify",
    value: function identify(distinctId, properties, options) {
      var previousDistinctId = this.getDistinctId();
      distinctId = distinctId || previousDistinctId;
      if (properties === null || properties === void 0 ? void 0 : properties.$groups) {
        this.groups(properties.$groups);
      }
      var allProperties = this.enrichProperties(_objectSpread(_objectSpread({}, properties), {}, {
        $anon_distinct_id: this.getAnonymousId(),
        $set: properties
      }));
      if (distinctId !== previousDistinctId) {
        this.setPersistedProperty(_types.PostHogPersistedProperty.AnonymousId, previousDistinctId);
        this.setPersistedProperty(_types.PostHogPersistedProperty.DistinctId, distinctId);
        this.reloadFeatureFlags();
      }
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(PostHogCore.prototype), "identifyStateless", this).call(this, distinctId, allProperties, options);
      return this;
    }
  }, {
    key: "capture",
    value: function capture(event, properties, options) {
      var distinctId = this.getDistinctId();
      if (properties === null || properties === void 0 ? void 0 : properties.$groups) {
        this.groups(properties.$groups);
      }
      var allProperties = this.enrichProperties(properties);
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(PostHogCore.prototype), "captureStateless", this).call(this, distinctId, event, allProperties, options);
      return this;
    }
  }, {
    key: "alias",
    value: function alias(_alias) {
      var distinctId = this.getDistinctId();
      var allProperties = this.enrichProperties({});
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(PostHogCore.prototype), "aliasStateless", this).call(this, _alias, distinctId, allProperties);
      return this;
    }
  }, {
    key: "autocapture",
    value: function autocapture(eventType, elements) {
      var properties = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var options = arguments.length > 3 ? arguments[3] : undefined;
      var distinctId = this.getDistinctId();
      var payload = {
        distinct_id: distinctId,
        event: '$autocapture',
        properties: _objectSpread(_objectSpread({}, this.enrichProperties(properties)), {}, {
          $event_type: eventType,
          $elements: elements
        })
      };
      this.enqueue('autocapture', payload, options);
      return this;
    }
  }, {
    key: "groups",
    value: function groups(_groups) {
      var existingGroups = this.props.$groups || {};
      this.register({
        $groups: _objectSpread(_objectSpread({}, existingGroups), _groups)
      });
      if (Object.keys(_groups).find(function (type) {
        return existingGroups[type] !== _groups[type];
      })) {
        this.reloadFeatureFlags();
      }
      return this;
    }
  }, {
    key: "group",
    value: function group(groupType, groupKey, groupProperties, options) {
      this.groups((0, _defineProperty2["default"])({}, groupType, groupKey));
      if (groupProperties) {
        this.groupIdentify(groupType, groupKey, groupProperties, options);
      }
      return this;
    }
  }, {
    key: "groupIdentify",
    value: function groupIdentify(groupType, groupKey, groupProperties, options) {
      var distinctId = this.getDistinctId();
      var eventProperties = this.enrichProperties({});
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(PostHogCore.prototype), "groupIdentifyStateless", this).call(this, groupType, groupKey, groupProperties, options, distinctId, eventProperties);
      return this;
    }
  }, {
    key: "personProperties",
    value: function personProperties(properties) {
      var existingProperties = this.getPersistedProperty(_types.PostHogPersistedProperty.PersonProperties) || {};
      this.setPersistedProperty(_types.PostHogPersistedProperty.PersonProperties, _objectSpread(_objectSpread({}, existingProperties), properties));
      return this;
    }
  }, {
    key: "groupProperties",
    value: function groupProperties(properties) {
      var existingProperties = this.getPersistedProperty(_types.PostHogPersistedProperty.GroupProperties) || {};
      if (Object.keys(existingProperties).length !== 0) {
        Object.keys(existingProperties).forEach(function (groupType) {
          existingProperties[groupType] = _objectSpread(_objectSpread({}, existingProperties[groupType]), properties[groupType]);
          delete properties[groupType];
        });
      }
      this.setPersistedProperty(_types.PostHogPersistedProperty.GroupProperties, _objectSpread(_objectSpread({}, existingProperties), properties));
      return this;
    }
  }, {
    key: "decideAsync",
    value: function decideAsync() {
      var sendAnonDistinctId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      if (this._decideResponsePromise) {
        return this._decideResponsePromise;
      }
      return this._decideAsync(sendAnonDistinctId);
    }
  }, {
    key: "_decideAsync",
    value: function () {
      var _decideAsync2 = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee10() {
        var _this9 = this;
        var sendAnonDistinctId,
          distinctId,
          groups,
          personProperties,
          groupProperties,
          extraProperties,
          _args10 = arguments;
        return _regenerator["default"].wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                sendAnonDistinctId = _args10.length > 0 && _args10[0] !== undefined ? _args10[0] : true;
                distinctId = this.getDistinctId();
                groups = this.props.$groups || {};
                personProperties = this.getPersistedProperty(_types.PostHogPersistedProperty.PersonProperties) || {};
                groupProperties = this.getPersistedProperty(_types.PostHogPersistedProperty.GroupProperties) || {};
                extraProperties = {
                  $anon_distinct_id: sendAnonDistinctId ? this.getAnonymousId() : undefined
                };
                this._decideResponsePromise = (0, _get2["default"])((0, _getPrototypeOf2["default"])(PostHogCore.prototype), "getDecide", this).call(this, distinctId, groups, personProperties, groupProperties, extraProperties).then(function (res) {
                  if (res === null || res === void 0 ? void 0 : res.featureFlags) {
                    var newFeatureFlags = res.featureFlags;
                    var newFeatureFlagPayloads = res.featureFlagPayloads;
                    if (res.errorsWhileComputingFlags) {
                      var currentFlags = _this9.getPersistedProperty(_types.PostHogPersistedProperty.FeatureFlags);
                      var currentFlagPayloads = _this9.getPersistedProperty(_types.PostHogPersistedProperty.FeatureFlagPayloads);
                      newFeatureFlags = _objectSpread(_objectSpread({}, currentFlags), res.featureFlags);
                      newFeatureFlagPayloads = _objectSpread(_objectSpread({}, currentFlagPayloads), res.featureFlagPayloads);
                    }
                    _this9.setKnownFeatureFlags(newFeatureFlags);
                    _this9.setKnownFeatureFlagPayloads(newFeatureFlagPayloads);
                  }
                  return res;
                })["finally"](function () {
                  _this9._decideResponsePromise = undefined;
                });
                return _context10.abrupt("return", this._decideResponsePromise);
              case 8:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));
      function _decideAsync() {
        return _decideAsync2.apply(this, arguments);
      }
      return _decideAsync;
    }()
  }, {
    key: "setKnownFeatureFlags",
    value: function setKnownFeatureFlags(featureFlags) {
      this.setPersistedProperty(_types.PostHogPersistedProperty.FeatureFlags, featureFlags);
      this._events.emit('featureflags', featureFlags);
    }
  }, {
    key: "setKnownFeatureFlagPayloads",
    value: function setKnownFeatureFlagPayloads(featureFlagPayloads) {
      this.setPersistedProperty(_types.PostHogPersistedProperty.FeatureFlagPayloads, featureFlagPayloads);
    }
  }, {
    key: "getFeatureFlag",
    value: function getFeatureFlag(key) {
      var featureFlags = this.getFeatureFlags();
      if (!featureFlags) {
        return undefined;
      }
      var response = featureFlags[key];
      if (response === undefined) {
        response = false;
      }
      if (this.sendFeatureFlagEvent && !this.flagCallReported[key]) {
        this.flagCallReported[key] = true;
        this.capture('$feature_flag_called', {
          $feature_flag: key,
          $feature_flag_response: response
        });
      }
      return response;
    }
  }, {
    key: "getFeatureFlagPayload",
    value: function getFeatureFlagPayload(key) {
      var payloads = this.getFeatureFlagPayloads();
      if (!payloads) {
        return undefined;
      }
      var response = payloads[key];
      if (response === undefined) {
        return null;
      }
      return this._parsePayload(response);
    }
  }, {
    key: "getFeatureFlagPayloads",
    value: function getFeatureFlagPayloads() {
      var _this10 = this;
      var payloads = this.getPersistedProperty(_types.PostHogPersistedProperty.FeatureFlagPayloads);
      if (payloads) {
        return Object.fromEntries(Object.entries(payloads).map(function (_ref4) {
          var _ref5 = (0, _slicedToArray2["default"])(_ref4, 2),
            k = _ref5[0],
            v = _ref5[1];
          return [k, _this10._parsePayload(v)];
        }));
      }
      return payloads;
    }
  }, {
    key: "getFeatureFlags",
    value: function getFeatureFlags() {
      var flags = this.getPersistedProperty(_types.PostHogPersistedProperty.FeatureFlags);
      var overriddenFlags = this.getPersistedProperty(_types.PostHogPersistedProperty.OverrideFeatureFlags);
      if (!overriddenFlags) {
        return flags;
      }
      flags = flags || {};
      for (var key in overriddenFlags) {
        if (!overriddenFlags[key]) {
          delete flags[key];
        } else {
          flags[key] = overriddenFlags[key];
        }
      }
      return flags;
    }
  }, {
    key: "getFeatureFlagsAndPayloads",
    value: function getFeatureFlagsAndPayloads() {
      var flags = this.getFeatureFlags();
      var payloads = this.getFeatureFlagPayloads();
      return {
        flags: flags,
        payloads: payloads
      };
    }
  }, {
    key: "isFeatureEnabled",
    value: function isFeatureEnabled(key) {
      var response = this.getFeatureFlag(key);
      if (response === undefined) {
        return undefined;
      }
      return !!response;
    }
  }, {
    key: "reloadFeatureFlags",
    value: function reloadFeatureFlags(cb) {
      this.decideAsync().then(function (res) {
        cb === null || cb === void 0 ? void 0 : cb(undefined, res === null || res === void 0 ? void 0 : res.featureFlags);
      })["catch"](function (e) {
        cb === null || cb === void 0 ? void 0 : cb(e, undefined);
        if (!cb) {
          console.log('[PostHog] Error reloading feature flags', e);
        }
      });
    }
  }, {
    key: "reloadFeatureFlagsAsync",
    value: function () {
      var _reloadFeatureFlagsAsync = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee11() {
        var sendAnonDistinctId,
          _a,
          _args11 = arguments;
        return _regenerator["default"].wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                sendAnonDistinctId = _args11.length > 0 && _args11[0] !== undefined ? _args11[0] : true;
                _context11.next = 3;
                return this.decideAsync(sendAnonDistinctId);
              case 3:
                _context11.t1 = _a = _context11.sent;
                _context11.t0 = _context11.t1 === null;
                if (_context11.t0) {
                  _context11.next = 7;
                  break;
                }
                _context11.t0 = _a === void 0;
              case 7:
                if (!_context11.t0) {
                  _context11.next = 11;
                  break;
                }
                _context11.t2 = void 0;
                _context11.next = 12;
                break;
              case 11:
                _context11.t2 = _a.featureFlags;
              case 12:
                return _context11.abrupt("return", _context11.t2);
              case 13:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));
      function reloadFeatureFlagsAsync() {
        return _reloadFeatureFlagsAsync.apply(this, arguments);
      }
      return reloadFeatureFlagsAsync;
    }()
  }, {
    key: "onFeatureFlags",
    value: function onFeatureFlags(cb) {
      var _this11 = this;
      return this.on('featureflags', (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee12() {
        var flags;
        return _regenerator["default"].wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                flags = _this11.getFeatureFlags();
                if (flags) {
                  cb(flags);
                }
              case 2:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12);
      })));
    }
  }, {
    key: "onFeatureFlag",
    value: function onFeatureFlag(key, cb) {
      var _this12 = this;
      return this.on('featureflags', (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee13() {
        var flagResponse;
        return _regenerator["default"].wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                flagResponse = _this12.getFeatureFlag(key);
                if (flagResponse !== undefined) {
                  cb(flagResponse);
                }
              case 2:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13);
      })));
    }
  }, {
    key: "overrideFeatureFlag",
    value: function overrideFeatureFlag(flags) {
      if (flags === null) {
        return this.setPersistedProperty(_types.PostHogPersistedProperty.OverrideFeatureFlags, null);
      }
      return this.setPersistedProperty(_types.PostHogPersistedProperty.OverrideFeatureFlags, flags);
    }
  }]);
  return PostHogCore;
}(PostHogCoreStateless);
exports.PostHogCore = PostHogCore;